import React from 'react';

import { Dentist } from '@/data/Dentists';
import { formatDentistName } from '@/utils/helpers/formatDentistName';

import './ScheduleFlowSummary.css';

interface ScheduleFlowSummaryProps {
  dentist?: Dentist | null;
  showEstimate?: boolean;
}

const ScheduleFlowSummary: React.FC<ScheduleFlowSummaryProps> = ({
  dentist,
  showEstimate
}) => {
  const labels = {
    dentist: 'Dentist',
    estimatedTime: 'Estimated Completion Time'
  };

  return (
    <div id="scheduleFlowSummary">
      {dentist && (
        <div className="scheduleFlowDetail">
          <p className="label">{labels.dentist}</p>
          <p className="value">
            {formatDentistName({
              dentist,
              returnDentistFullName: true
            })}
          </p>
        </div>
      )}
      {showEstimate && (
        <div className="scheduleFlowDetail">
          <p className="label">{labels.estimatedTime}</p>
          <p className="value">~3 minutes</p>
        </div>
      )}
    </div>
  );
};

export default ScheduleFlowSummary;
